module.exports = __webpack_public_path__ + "static/img/6.7246a294.png";